import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";

export const useDocumentQueries = () => {
  const api = useApi();
  const projectId = useProjectId();

  return {
    listRoots: () =>
      queryOptions({
        queryKey: QUERY_KEYS.DOCUMENTS_ROOT_LIST(projectId),
        queryFn: () => api.getDocumentsV1(),
        select: (res) => {
          const { rootFolders } = commonAPIDataSelector(res);

          return rootFolders;
        },
      }),
    listDocuments: ({ folderId, page }: { folderId: string; page?: number }) => {
      const limit = 10;
      const query = {
        Limit: limit,
        Offset: (page || 0) * limit,
      };

      return queryOptions({
        queryKey: QUERY_KEYS.DOCUMENTS_LIST(projectId, folderId, query),
        queryFn: () => api.getDocumentsDetailsV1(folderId, query),
        select: commonAPIDataSelector,
      });
    },
    fileDetails: ({ folderId, fileId }: { folderId: string; fileId: string }) =>
      queryOptions({
        queryKey: QUERY_KEYS.DOCUMENTS_FILE_DETAILS(projectId, folderId, fileId),
        queryFn: () => api.getDocumentsFileDetailsV1(fileId),
        select: commonAPIDataSelector,
      }),
    folderDetails: ({ folderId }: { folderId: string }) =>
      queryOptions({
        queryKey: QUERY_KEYS.DOCUMENTS_LIST_DETAILS(projectId, folderId),
        queryFn: () => api.getDocumentsFolderDetailsV1(folderId),
        select: commonAPIDataSelector,
      }),
    rootFolderDetails: ({ folderId }: { folderId: string }) =>
      queryOptions({
        queryKey: QUERY_KEYS.DOCUMENTS_ROOT_FOLDER_DETAILS(projectId, folderId),
        queryFn: () => api.getDocumentsRootFolderDetailsV1(folderId),
        select: commonAPIDataSelector,
        gcTime: 0,
      }),
    defaultFolderPermissions: () =>
      queryOptions({
        queryKey: QUERY_KEYS.DOCUMENTS_ROOT_DEFAULT_PERMISSIONS(projectId),
        queryFn: () => api.getPermissionsDefaultFolderV1(),
        select: commonAPIDataSelector,
      }),
  };
};
